export default "__VITE_ASSET__CaRER2_F__"